import { FC, MouseEvent } from 'react';
import { ExternalLink, Flex, FlexProps, Text } from 'roo-ui/components';

interface HelpItemProps extends FlexProps {
  title: string;
  message: string;
  linkLabel: string;
  link: string;
  onClick: (event: MouseEvent<any>) => void;
}

const HelpItem: FC<HelpItemProps> = ({ title, message, linkLabel, link, onClick, ...flexProps }) => (
  <Flex flexDirection="column" maxWidth="498px" {...flexProps}>
    <Text fontSize="xl">{title}</Text>
    <Text fontSize="lg" mt={2}>
      {message}
    </Text>
    <Text fontSize="lg" color="brand.primary">
      <ExternalLink underline href={link} onClick={onClick}>
        {linkLabel}
      </ExternalLink>
    </Text>
  </Flex>
);

export default HelpItem;
